module.exports = __webpack_public_path__ + "static/p12-595102c57b547c34d830dbb1e62de95e.jpg";